import fetch from "apiMiddleware";

export const login = data =>
  fetch({
    method: "POST",
    url: "users/token-auth/",
    data,
  });

export const passwordReset = data =>
  fetch({
    method: "POST",
    url: "users/password/reset/",
    data,
  });

export const passwordSet = data =>
  fetch({
    method: "POST",
    url: "users/password/set/",
    data,
  });

export const passwordResetConfirm = data =>
  fetch({
    method: "POST",
    url: "users/password/reset/confirm/",
    data,
  });

export const getMyProfile = () =>
  fetch({
    method: "GET",
    url: "users/me/",
  });

export const patchMyProfile = data =>
  fetch({
    method: "PATCH",
    url: "users/me/",
    data,
  });

export const getUsers = search =>
  fetch({
    method: "GET",
    url: `users/users/${search}`,
  });

export const getUser = id =>
  fetch({
    url: `users/users/${id}/`,
  });

export const registerUser = data =>
  fetch({
    method: "POST",
    url: `users/register/`,
    data,
  });

export const putUser = (id, data) =>
  fetch({
    method: "PUT",
    url: `users/users/${id}/`,
    data,
  });

export const deleteUser = id =>
  fetch({
    method: "DELETE",
    url: `users/users/${id}/`,
  });

// export const patchUser = (id, data) => fetch({
//   method: 'PATCH',
//   url: `users/users/${id}/`,
//   data
// });



// WEBPACK FOOTER //
// ./src/api/users/calls.js